export var SIDEBAR_ITEMS = 'SIDEBAR_ITEMS';
export var SIDEBAR_OPEN = 'SIDEBAR_OPEN';
export var MOBILEMENU_EXPANDED = 'MOBILEMENU_EXPANDED';
export var USERMENU_LAYOUT = 'USERMENU_LAYOUT';
export var ACTIVE_TASKID = 'ACTIVE_TASKID';
export var DRAWER_OPEN = 'DRAWER_OPEN';
